module.exports = __webpack_public_path__ + "static/media/equalizer.8ca8d2e5.png";